import { Box, Button, styled, Typography } from '@mui/material';
import { FIXED_FOOTER_HEIGHT } from 'src/constants';

export const Container = styled(Box)`
  max-height: calc(100vh - ${FIXED_FOOTER_HEIGHT}px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ButtonContainer = styled(Box)`
  right: 20px;
  bottom: 10px;
  position: fixed;
`;

export const ButtonWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;

export const Content = styled(Box)`
  height: calc(100vh - 400px);
  display: flex;
  flex-direction: column;

  overflow-y: scroll;
`;

export const LocationText = styled(Typography)`
  padding-bottom: 5px;
`;
export const TextContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 5px;
  border-bottom: 1px solid ${theme.palette.brand.black};
  `,
);
export const AssignLocationButtonContainer = styled(Box)`
  margin-right: 15px;
`;
export const StyledButton = styled(Button)`
  padding: 5px 10px;
`;

export const NoResultContainer = styled(Box)`
  margin-right: 10px;
`;

export const ButtonGroupContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
